import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@material-ui/core';
import Label from 'src/components/Label';
import axios from 'src/utils/axios';
import { getIslerAdet, getClosedJobCount, getMalzemeIhtiyacAdet, getYorumAdet, getUyariAdet } from 'src/utils/storage/NavBarAdet';
import { getUser } from 'src/utils/Common';
import icons from 'src/utils/icons';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';


const functionMap = {

};

// TenantId = 118 için gizlenecek menü TranslationKey'leri
const hiddenMenusForTenant118 = [
  'MaterialServiceShopReport',
  'lblMaterialServiceShopReport',
  'WatchList',
  'lblWatchList',
  'Watch List',
  'ServiceShopMaterial',
  'lblServiceShopMaterial',
  'ServiceShopOffWork',
  'lblServiceShopOffWork',
  'Servis_iletisim',
  'ServiceContact',
  'lblServiceContact',
  'ProductRelease',
  'lblProductRelease',
  'OwnEngineeringMaterials',
  'lblOwnEngineeringMaterials'
];

const NavConfig = () => {
  const [menuItems, setMenuItems] = useState([]);
  const SessionUser = getUser();
  const { t } = useTranslation('navigation');

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await axios.get(`/GetAuthorizedMenus/${SessionUser.TechnicianId}/3`);
        let data = response.data;

        // Debug: Menü TranslationKey'lerini konsola yazdır
        console.log('TenantId:', SessionUser.TenantId, typeof SessionUser.TenantId);
        console.log('Menu TranslationKeys:', data?.map(item => item.TranslationKey));

        if (Array.isArray(data)) {
          // TenantId = 118 için filtreleme ve sıralama
          // eslint-disable-next-line eqeqeq
          if (SessionUser.IsIhpTenant) {
            // Kırmızı işaretli menüleri gizle
            data = data.filter(item => !hiddenMenusForTenant118.includes(item.TranslationKey));

            // Partner menülerini Yardim'ın üstüne taşı
            const partnerKeys = [
              'TradePartner-RepairForConsumer',
              'TradePartner-WorkOrderList',
              'lblPartnerReport',
              'PartnerReport'
            ];

            const helpIndex = data.findIndex(item =>
              item.TranslationKey === 'lblHelp' ||
              item.TranslationKey === 'Yardim' ||
              item.TranslationKey === 'Help'
            );

            if (helpIndex !== -1) {
              // Partner menülerini bul ve çıkar
              const partnerItems = [];
              for (let i = data.length - 1; i >= 0; i--) {
                if (partnerKeys.includes(data[i].TranslationKey)) {
                  partnerItems.unshift(data.splice(i, 1)[0]);
                }
              }

              // Yardim'ın yeni index'ini bul ve Partner'ları oraya ekle
              const newHelpIndex = data.findIndex(item =>
                item.TranslationKey === 'lblHelp' ||
                item.TranslationKey === 'Yardim' ||
                item.TranslationKey === 'Help'
              );

              if (newHelpIndex !== -1 && partnerItems.length > 0) {
                data.splice(newHelpIndex, 0, ...partnerItems);
              }
            }
          }

          setMenuItems(data);
        } else {
          console.error('Menu items API response is not an array:', data);
        }
      } catch (error) {
        console.error('Error fetching menu items', error);
      }
    };

    fetchMenuItems();
  }, [SessionUser.TechnicianId]);


  const colorsArray = [colors.green[500], colors.red[500], colors.blue[500], '#8b8b00']; // Renk dizisi


  const generateMenu = (menuItems) => {
    return {
      subheader: 'İşlemler',
      items: menuItems.map((item, index) => {
        const labelFunction = functionMap[item.FunctionName];

        const labelContent = labelFunction ? labelFunction() : null;

        const color = colorsArray[index % colorsArray.length]; // Döngüsel renk ataması


        return {
          title: t(item.TranslationKey),
          href: item.RouteUrl,
          icon: item.IconName,
          label: labelFunction ? (
            <Label color={color} shape="rounded">
              {labelContent?.toString()}
            </Label>
          ) : null,
          items: item.SubMenuItems ? generateMenu(item.SubMenuItems).items : undefined, // Alt menü varsa recursive çağır
        };
      }),
    };
  };


  if (menuItems.length === 0) {
    return null;
  }

  // Menü verisini döndür
  return [generateMenu(menuItems)];
};

export default NavConfig;
